const BINARY_MULTIPLIER = 1024;

const roundToTwo = (value: number) => Number(Math.round(value * 100) / 100);

export const formatFileSize = (kilobytes: number): string => {
  if (!kilobytes) {
    return "0 KB";
  }

  const fileSizeInBytes: number = kilobytes / 1024;

  if (fileSizeInBytes < BINARY_MULTIPLIER) {
    return `${roundToTwo(fileSizeInBytes)} KB`;
  }

  const megabytes = Math.abs(fileSizeInBytes / BINARY_MULTIPLIER);

  if (megabytes > BINARY_MULTIPLIER) {
    const gigabytes = Math.abs(megabytes / BINARY_MULTIPLIER);

    return `${roundToTwo(gigabytes)} GB`;
  }

  return `${roundToTwo(megabytes)} MB`;
};
